import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import api from './api/index';

import Backend from 'i18next-http-backend';

let lang = 'nl-NL';
if(location.hostname.includes(".nl")){
  lang = 'nl-NL';
}else if (location.hostname.includes(".org")){
  lang = 'en-GB';
}

i18n
  .use(Backend)
  .use(initReactI18next)
  .init({
    lng: lang,
    fallbackLng: 'en-GB',
    saveMissing: true,
    debug: false,
    backend: {
      loadPath: '/api/locales/{{lng}}',
      addPath: '/api/locales/add/{{lng}}',
      request: function (options, url, payload, callback) {
        const lng = url.split("/").pop();
        if(url.includes('add')){
          callback(api.addLocale(lng, payload));
        }else{
          api.getLocale(lng).then(response => {
            if(response.status === 200){
              callback(null, {status: 200, data: response.data});
            }
          });
        }
      },
    },
    
    interpolation: {
      escapeValue: false, // not needed for react as it escapes by default
    }
  });


export default i18n;